module.exports = __webpack_public_path__ + "img/puzzle2_p.9302667a.svg";